import React, { useEffect } from "react";
import "./modalCommon.scss";
import type { BaseModalModel } from "../../type/modal";


export const BaseModal: React.FC<BaseModalModel> = ({
  open,
  onClose,
  children,
  size = "md",
}) => {
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (open) document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div
        className={`modal-container modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
